import React, { useState } from "react";
import Icon from "components/AppIcon";
import Image from "components/AppImage";


const typeFilters = ["All", "upgrade", "churn", "support", "milestone", "nps", "expansion", "renewal", "downgrade"];

const typeMeta = {
  upgrade: { icon: "TrendingUp", iconColor: "#059669" },
  support: { icon: "MessageSquare", iconColor: "#D97706" },
  churn: { icon: "AlertTriangle", iconColor: "#DC2626" },
  milestone: { icon: "CheckCircle", iconColor: "#059669" },
  nps: { icon: "Star", iconColor: "#F59E0B" },
  expansion: { icon: "UserPlus", iconColor: "#1E40AF" },
  renewal: { icon: "FileCheck", iconColor: "#7C3AED" },
  downgrade: { icon: "TrendingDown", iconColor: "#DC2626" },
};

export default function ActivityFeed({ activities: activitiesProp }) {
  const [filter, setFilter] = useState("All");

  const initials = (name) =>
    String(name || '?')
      .split(' ')
      .map((n) => n?.[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase();

  const activityList = (activitiesProp || []).map((a, idx) => ({
    id: a?.id || idx + 1,
    customer: a.customer,
    avatar: a.avatar || null,
    avatarAlt: a.avatarAlt || `${a.customer} logo`,
    action: a.action,
    type: a.type,
    icon: typeMeta?.[a.type]?.icon || "Activity",
    iconColor: typeMeta?.[a.type]?.iconColor || "#1E40AF",
    time: a.time,
    value: a.value,
  }));

  const filtered = filter === "All" ? activityList : activityList?.filter((a) => a?.type === filter);

  return (
    <div
      className="rounded-xl border flex flex-col"
      style={{
        background: "var(--color-card)",
        borderColor: "var(--color-border)",
        boxShadow: "var(--shadow-md)",
        padding: "20px",
        height: "100%"
      }}>
      
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>
            Activity Feed
          </h3>
          <p className="font-caption text-xs mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            Customer events from conversations and calls
          </p>
        </div>
      </div>
      {/* Filter chips */}
      <div className="flex gap-1.5 overflow-x-auto pb-2 mb-3 flex-shrink-0" style={{ scrollbarWidth: "none" }}>
        {["All", "upgrade", "churn", "support"]?.map((f) =>
        <button
          key={f}
          onClick={() => setFilter(f)}
          className="flex-shrink-0 px-2.5 py-1 rounded-full font-caption text-xs font-medium transition-all duration-150"
          style={{
            background: filter === f ? "var(--color-primary)" : "var(--color-muted)",
            color: filter === f ? "#fff" : "var(--color-text-secondary)",
            minHeight: 28
          }}>
          
            {f?.charAt(0)?.toUpperCase() + f?.slice(1)}
          </button>
        )}
      </div>
      {/* Feed list */}
      <div className="flex-1 overflow-y-auto flex flex-col gap-2" style={{ maxHeight: 380 }}>
        {filtered?.map((item) =>
        <div
          key={item?.id}
          className="flex items-start gap-3 p-2.5 rounded-lg transition-all duration-150 hover:bg-muted cursor-pointer"
          style={{ border: "1px solid var(--color-border)" }}>
          
            <div className="relative flex-shrink-0">
              <div className="w-8 h-8 rounded-full overflow-hidden"
                style={{ background: "var(--color-muted)" }}>
                {item?.avatar ? (
                  <Image
                    src={item?.avatar}
                    alt={item?.avatarAlt}
                    className="w-full h-full object-cover" />
                ) : (
                  <span className="flex items-center justify-center w-full h-full text-[10px] font-bold font-caption"
                    style={{ color: "var(--color-text-secondary)" }}>
                    {initials(item?.customer)}
                  </span>
                )}
              </div>
              <div
              className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full flex items-center justify-center"
              style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
              
                <Icon name={item?.icon} size={9} color={item?.iconColor} strokeWidth={2.5} />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-caption text-xs font-semibold truncate" style={{ color: "var(--color-foreground)" }}>
                {item?.customer}
              </p>
              <p className="font-caption text-xs line-clamp-2" style={{ color: "var(--color-text-secondary)" }}>
                {item?.action}
              </p>
              <div className="flex items-center justify-between mt-1">
                <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
                  {item?.time}
                </span>
                {item?.value &&
              <span
                className="font-data text-xs font-medium"
                style={{
                  color: item?.value?.startsWith("-") ? "#DC2626" : "#059669"
                }}>
                
                    {item?.value}
                  </span>
              }
              </div>
            </div>
          </div>
        )}
      {filtered?.length === 0 && (
          <p className="font-caption text-sm text-center py-6" style={{ color: "var(--color-text-secondary)" }}>
            {filter === "All" ? "No activity yet — events will appear here" : `No ${filter} activity yet`}
          </p>
        )}
      </div>
    </div>);

}